module.exports = __webpack_public_path__ + "img/minas_gerais.be64256e.jpg";